$(document).on("submit", "form", e => {
  const mixpanel_input = $(e.target).find("input[name='mixpanel_distinct_id']");
  if (mixpanel_input.length) {
    mixpanel_input.val(Mixpanel.get_distinct_id());
  }
});
